import { Slot } from '@radix-ui/react-slot';
import { cn } from '@/utils/cn';

type ButtonProps = {
  invert?: boolean;
  children: React.ReactNode;
  asChild?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const baseClassName =
  'block relative px-[1.4em] py-[0.6em] font-bold text-lg rounded-md disabled:opacity-50 disabled:cursor-not-allowed ';
const colorClassName =
  'bg-linear-to-br from-black via-gray-700 to-black text-yellow-400 border-2 border-gray-500';
const invertColorClassName =
  'bg-linear-to-br from-amber-400 via-yellow-200 to-amber-400 text-gray-800 border-2 border-yellow-500';

export const Button = ({
  children,
  onClick,
  disabled,
  className,
  asChild,
  invert = false,
}: ButtonProps) => {
  const Comp = asChild ? Slot : 'button';

  return (
    <Comp
      type={asChild ? undefined : 'button'}
      className={cn(
        baseClassName,
        colorClassName,
        invert && invertColorClassName,
        className,
      )}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Comp>
  );
};
